import {useRef} from 'react'
import emailjs from '@emailjs/browser';
import { useState } from 'react';
import { BsCheckCircle, BsEmojiFrownFill } from 'react-icons/bs';


//Motion
import { motion } from 'framer-motion'

//varients
import { fadeIn } from '../variants'

const Contact = () => {
  const form = useRef();
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [submissionFail, setSubmissionFail] = useState(false);


  const handleSuccess = () => {
    setSubmissionSuccess(true);

    // Set a timer to reset the submission success
    setTimeout(() => {
      setSubmissionSuccess(false);
    }, 5000);
  };

  const handleFail = () => {
    setSubmissionFail(true);

    // Set a timer to reset the submission success
    setTimeout(() => {
      setSubmissionFail(false);
    }, 5000);
  };

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_xfw3bzn', 'template_vgjohy1', form.current, 'zw2rxbqIzfqeButcU')
    .then((result) => {
      console.log(result.text);
      handleSuccess();
      e.target.reset();
    }, (error) => {
      console.log(error.text);
      handleFail()
    });
};



  return (
    <section id="contact" className="mt-[200px] py-16 lg:section">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">
          {/* text */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex justify-start items-center"
          >
            <div>
              <h4 className="text-2xl lg:text-4xl uppercase text-accent font-extrabold mb-2 tracking-wide">
                Get in touch
              </h4>
              <h2 className="text-[45px] lg:text-[90px] leading-none mb-12">
                let's work <span>together!!</span>
              </h2>
            </div>
          </motion.div>

          {/* Form */}
          <motion.form ref={form} onSubmit={sendEmail}
            variants={fadeIn('left', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 border rounded-2xl flex flex-col gap-y-6  pb-24 p-6 items-start"
          >
            <input
              type="email"
              id='email'
              required
              name='user_email'
              className="bg-transparent border-b py-3 border-white w-full placeholder:text-white focus:border-accent outline-none transition-all"
              placeholder="Your Email"
            />
            <input
              type="text"
              name='user_name'
              className="bg-transparent border-b py-3 border-white w-full placeholder:text-white focus:border-accent outline-none transition-all"
              placeholder="Your Name"
            />
            <textarea
              name='message'
              className="bg-transparent border-b py-12 border-white w-full placeholder:text-white focus:border-accent outline-none transition-all resize-none mb-12 mt-[5%]"
              placeholder="Your Message"
            ></textarea>
            <button className="btn btn-lg mx-auto">Submit Message</button>
          </motion.form>

      {/* POP-UP CARD FOR SUCCESS*/}
      {submissionSuccess && (
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="fixed top-1 left-1/5 mr-[15px] transform -translate-x-1/2 -translate-y-1/2 border-green-500 border-l-[20px]  p-4 bg-white rounded-lg shadow-lg flex items-center justify-center"
          >
            <BsCheckCircle className="text-green-500 mr-2 text-4xl" />
            <span className="text-lg font-semibold text-black">
              Thank you, Your message has been submitted successfully!
            </span>
          </motion.div>         
)}
  {/* POP-UP CARD FOR FAIL*/}
        {submissionFail && (
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="fixed top-1 left-1/5 mr-[15px] transform -translate-x-1/2 -translate-y-1/2 border-red-500 border-l-[20px]  p-4 bg-white rounded-lg shadow-lg flex items-center justify-center"
          >
            <BsEmojiFrownFill className="text-red-500 mr-2 text-4xl" />
            <span className="text-lg font-semibold text-black">
              So sorry!, Something Went Wrong. Please
               Resend Message
            </span>
          </motion.div>         
)}
        </div>
      </div>
    </section>
  )
}

export default Contact
